import $ from 'jquery';
import 'magnific-popup/dist/jquery.magnific-popup';
import { runnerV1Semantics } from '../runner-v1/runner-v1';
import 'slick';
import {
    slickCommonOptions,
} from './../../scripts/config';
import { render } from 'react-dom';

const tagListV13Semantics = {
    mainWrapClass: 'tag-list-v13',
    isInitializedAttribute: 'data-is-initialized',
    instanceIdAttribute: 'data-instance-id',
    popupIdClass: 'tag-list-v13__popup',
    offsetPopupTop: 16,
    hasPopup: 'tag-list-v13__item-select',
    filterOpenAttr: 'data-open-filterable-block-id',
    filterAttr: 'data-filterable-block-id',
    // типы фильтров
    filterTypes: [
        {
            type: 'range',
            hasClass: ' filter-block-range-v1'
        },
        {
            type: 'select',
            hasClass: ' filter-block-select-v1'
        },
        {
            type: 'checkbox',
            hasClass: ' filter-block-checkbox-v1'
        }
    ],
    filterPopupSelectedClass: 'top-filter__label_checked',

    // deps
    activeElementClass: 'tag-list-item-v13__active',
    elementClass: 'tag-list-v13__item',
    linkClass: 'tag-list-item-v13__link',
    mfpContainerClass: 'mfp-content',
    popupContainerClass: 'product-filter-popup-v1',
    originalFilterContainerClass: 'catalog-filtered-grid__common-wrap',
    // \deps
}

$(function () {
    TagListV13.init()
})

class TagListV13 {

    constructor() {
        this.pluginInstances = {};
    }

    static init() {
        let roots = $(`.${tagListV13Semantics.mainWrapClass}`);
        if (roots.length === 0) {
            return false;
        }
        if (!window || !window.widgets || !window.widgets.tagListV13) {
            window.widgets.tagListV13 = new TagListV13();
        }
        /**
         * Checking other instances
         */
        roots.each((index, el) => {
            let isInitialized =
                ($(el).attr(`${tagListV13Semantics.isInitializedAttribute}`) === 'true');

            if (!isInitialized) {
                window.widgets.tagListV13.registerInstance($(el));
                window.widgets.tagListV13.registerListeners($(el));
            }
        });
    }

    registerInstance(el) {
        let instanceId =
            el.attr(`${tagListV13Semantics.instanceIdAttribute}`) || false;

        if (instanceId === false) {
            throw new Error(`Invalid jQuery selector for ` +
                `instance slider with id [${instanceId}]`);
        }

        let commonPluginOptions =
            el.data(
                `${tagListV13Semantics.commonPluginOptionsAttribute}`.replace('data-', '')
            ) || {};

        let pluginOptions = Object.assign({},
            slickCommonOptions,
            commonPluginOptions,
            {
                arrows: false,
                dots: false,
                swipeToSlide: true,
                infinite: false,
                variableWidth: true,
                slidesToScroll: 1,

            }
        );
        try {
            let slick = el.slick(pluginOptions);

            this.registerSlickEvents(slick);

            el.attr(`${tagListV13Semantics.isInitializedAttribute}`, true);
            window.widgets.tagListV13.pluginInstances[instanceId] = slick;
        } catch (e) {
            el.hide();
            throw e;
        }
    }

    registerListeners(el) {
        let elements = $(`.${tagListV13Semantics.mainWrapClass}[${
            tagListV13Semantics
                .instanceIdAttribute
        }="${
            el.attr(tagListV13Semantics
                .instanceIdAttribute)
        }"]`);

        elements.on(
            'click',
            `.${tagListV13Semantics.elementClass}`,
            (e) => {
                e.preventDefault();
                let current = $(e.currentTarget);
                if (current.hasClass(tagListV13Semantics.hasPopup)) {
                    // если надо открыть popup с фильтром
                    let filterId = current.attr(tagListV13Semantics.filterOpenAttr);
                    let filter = $(`[${tagListV13Semantics.filterAttr}="${filterId}"]`);
                    this.popupOpen(filter);
                } else if (current.is('[href]')) {
                    // переход по ссылке
                    document.location.href = current.attr('href');
                }
            }
        );

        $(window).on('resize', function () {
            //mvp
            window.widgets.tagListV13.recalculateOpenedPopup();
        });
    }

    recalculateOpenedPopup() {
        if (window.widgets.tagListV13.currentTarget && window.widgets.tagListV13.currentPopup) {
            window.widgets.tagListV13.calculatePopupCoords(
                window.widgets.tagListV13.currentTarget,
                window.widgets.tagListV13.currentPopup
            );
        }
    }

    registerSlickEvents(el) {
        let obj = this;
        //расстояние движение мыши при котором событие будет считаться не кликом, а перетаскиванием
        let minimalDistance = 10;
        let startX, startY, isDragging = false, clicked = false;
        el.on('mousedown touchstart', function (e) {
            isDragging = false;
            clicked = true;
            startX = e.pageX || e.originalEvent.touches[0].pageX;
            startY = e.pageY || e.originalEvent.touches[0].pageY;
        })
            .on('mousemove touchmove', function (e) {
                if (clicked) {
                    let moveX = e.pageX || e.originalEvent.touches[0].pageX;
                    let moveY = e.pageY || e.originalEvent.touches[0].pageY;
                    if (Math.abs(moveX - startX) > minimalDistance || Math.abs(moveY - startY) > minimalDistance) {
                        isDragging = true;
                        //window.widgets.tagListV13.closePopup()
                    }
                }
            })
            .on('mouseup touchend', function (e) {
                clicked = false;
                if (!isDragging) {
                    // obj.slideClickEvent(e);
                }
                isDragging = false;
            })
            .on('afterChange', function (e) {
                //window.widgets.tagListV13.closePopup()
            })
    }

    popupOpen(actionElement) {

        let filterType = this.detectFilterType(actionElement);

        $.magnificPopup.open({
            items: {
                src: `<div class="${tagListV13Semantics.popupIdClass} type-${filterType}"></div>`,
                type: 'inline'
            },
            overflowY: 'scroll',
            enableEscapeKey: false,
            fixedContentPos: true,
            closeMarkup: `<button title="Закрыть" type="button" class="js-popup-close mfp-close">
                    <span></span>
                        <svg><use xlink:href="` + iconSVG + `#close"></use></svg>
                </button>`,
            callbacks: {
                open: () => {
                    const $clonedElement = actionElement.clone(true);

                    $(`.${tagListV13Semantics.popupIdClass}`)
                        .append($clonedElement)
                        .append('<a class="button-link-v1 js-apply-top-filter" href="#">Показать</a>')
                    ;
                    // пост обработка после вставки фильтра в окно. в зависимости от типа фильтра
                    switch (filterType) {
                        case 'range':
                            let $slider = $clonedElement.find(`.${runnerV1Semantics.mainWrapClass}`);
                            //reInit слайдера
                            window.widgets.runnerV1.reInit($slider,'_popup');
                            break;
                        case 'select':
                            let $select = $clonedElement.find('select');

                            // нужно чтобы клонируемому селекту присваивалось правильное значение
                            // иначе не меняет значение. (может кэш браузера???)
                            if($select.length) {
                                $select.val(actionElement.find('select').val())
                            }
                            let $selectedOption = $select.find('option:selected');

                            // Если есть выбранная опция, и ее нет в списке первой opt группы то надо ее запушить
                            let firstOptGroup = $select.find('optgroup').first();
                            if (
                                $selectedOption.length
                                &&
                                !firstOptGroup.find('option[value="' + $selectedOption.val() + '"]').length
                            ) {
                                firstOptGroup.append($selectedOption);
                            }

                            $select.after(this.renderTopFilterSize($select))
                                .parent()
                                .addClass('catalog-filtered-grid__filter-options')
                            ;

                            // первоначальная установка значения.
                            if ($selectedOption.length) {
                                $clonedElement
                                    .find('input[value="' + $selectedOption.val() + '"]')
                                    .parent()
                                    .addClass(tagListV13Semantics.filterPopupSelectedClass)
                                    .siblings()
                                    .removeClass(tagListV13Semantics.filterPopupSelectedClass);
                            }
                            break;
                        case 'checkbox':
                            $clonedElement.find('input').each((i, el) => {
                                let id = 'top-filter__label_' + i;
                                let $el = $(el);

                                let hasColor = $(el)
                                    .siblings('.checkbox-v1__label')
                                    .find('.checkbox-v1__colorbox')
                                    .length > 0;

                                $el.wrap('<label class="top-filter__label '
                                    + ' js-top-filter__label" for="'
                                    + id
                                    + '"></label>'
                                );
                                $el.attr('id', id);
                                if(hasColor) {
                                    $el.closest('.catalog-filtered-grid__filter-option').
                                        addClass('top-filter__label_color');
                                }
                                this.setTopFilterCheckboxStatus($el);
                            });
                            break;
                    }
                    this.registerEvents()
                }
            }
        });
    }

    // события которые вешаются после отрисовки окон с фильтрами
    registerEvents() {
        $(`.${tagListV13Semantics.popupIdClass}`)
            // select-type
            .on('click', '.js-top-filter__label', (e) => {

                let $this = $(e.currentTarget);
                let $input = $this.find('input');
                let $selectElement = $this.siblings('select');
                let inputValue = $input.val();
                // Ищем аналогичный элемент в другом контейнере по name и value
                let $select = $(`.${tagListV13Semantics.originalFilterContainerClass}`).find(
                    `select[name="${$selectElement.attr('name')}"]`
                );

                // Ищем option с нужным value и выбираем его
                let $matchingOption = $select.find(`option[value="${inputValue}"]`);
                if ($matchingOption.length > 0) {
                    // Выбираем нужный option и триггерим change событие
                    $select.val(inputValue).trigger('change');
                }

                $this.addClass(tagListV13Semantics.filterPopupSelectedClass)
                    .siblings().removeClass(tagListV13Semantics.filterPopupSelectedClass);

                // let $select = $this.parent().find('select');
                //
                // $this.closest('._size').height(
                //     $this.closest('._size').height()
                // );

                // $this.after(
                //     this.renderTopFilterSize($select, true)
                // ).remove();

                this.setTopFilterCheckboxStatus(
                    $select.parent().find('input[value="' + $select.val() + '"]').first().prop('checked', true)
                );
            })
            // checkbox-type
            .on('click', '.catalog-filtered-grid__filter-option', function (e) {
                let $this = $(e.currentTarget);
                if($this.hasClass(tagListV13Semantics.filterPopupSelectedClass)) {
                     $this.removeClass(tagListV13Semantics.filterPopupSelectedClass)
                }
                else {
                    $this.addClass(tagListV13Semantics.filterPopupSelectedClass)
                }
                    // удаление других активных фильтров - убрал потомучто не понимаю зачем?
                    // может для селектов актульно
                    // $this.siblings()
                    // .removeClass(tagListV13Semantics.filterPopupSelectedClass)

                let inputElement = $this.find('input');
                let inputValue = inputElement.val();
                let inputName = inputElement.attr('name');
                // Ищем аналогичный элемент в другом контейнере по name и value
                let matchingElement = $(`.${tagListV13Semantics.originalFilterContainerClass}`)
                    .find(`input[name="${inputName}"][value="${inputValue}"]`);

                // Проверяем, найден ли аналогичный элемент, и отмечаем его, если найден
                if (matchingElement.length > 0) {
                    // Устанавливаем состояние checked в зависимости от текущего состояния
                    matchingElement.prop('checked', $this.hasClass(tagListV13Semantics.filterPopupSelectedClass));
                    // и тригируем событие
                    matchingElement.trigger('change');
                }
            })
            // кнопка применить фильтры
            .on('click', '.js-apply-top-filter', function(e) {
                $('.catalog-filtered-grid__filter-wrap .catalog-filtered-submit-btn').trigger('click');
                $(`.${tagListV13Semantics.popupIdClass} .mfp-close`).trigger('click');
                return true;
            })
        ;
    }

    detectFilterType(element) {
        const filterType
            = tagListV13Semantics.filterTypes.find(
            filter =>
                element.hasClass(filter.hasClass.trim())
        );
        return filterType ? filterType.type : null;
    }

    renderTopFilterSize($select, isOther = false) {
        let html = '';
        let selected = $select.val();
        if(isOther) {
            $select.find('optgroup').each((i, el) => {
                if ((i > 0) && ($(el).children().length > 0)) {
                    html += '<div class="top-filter__title">' + $(el).attr('label') + '</div>';
                    html += this.renderTopFilterSizeOption($(el), selected);
                }
            });
        }

        html += this.renderTopFilterSizeOption($select.find('optgroup').first(), selected);
        // html += '<label class="top-filter__label js-top-filter__label js-top-filter__label_other" for="option_other">' +
        //     '<div class="checkbox-v1__label">другой размер</div>' +
        //     '</label>';

        return html;
    }

    renderTopFilterSizeOption($optgroup, selected = null) {
        let html = '';
        $optgroup.find('option').each((i, el) => {

            let $el = $(el);
            let value = $el.val();

            if (value) {
                html += '<label class="top-filter__label js-top-filter__label" for="option_' + value + '_' + $optgroup.attr('label') + '">' +
                    '<input id="option_' + value + '_' + $optgroup.attr('label') + '" type="radio" name="top-filter__size" value="' + value + '" ' + (value === selected ? 'checked' : '') + '>' +
                    '<div class="checkbox-v1__label">' + $el.html() + '</div>' +
                    '</label>';
            }

        });

        return html;
    }

    setTopFilterCheckboxStatus($input) {
        if ($input.prop('checked')) {
            if ($input.attr('type') === 'radio') {
                $input.closest('.slider-v3-popup')
                    .find('.top-filter__label')
                    .removeClass('top-filter__label_checked');
            }
            $input.closest('.catalog-filtered-grid__filter-option')
                .addClass(tagListV13Semantics.filterPopupSelectedClass)
        } else {
            $input.closest('.catalog-filtered-grid__filter-option')
                .removeClass(tagListV13Semantics.filterPopupSelectedClass);
        }
    }

    reInit(instanceId) {
        if (this.pluginInstances[instanceId] !== undefined) {
            this.registerListeners(this.pluginInstances[instanceId]);
        } else {
            TagListV13.init()
        }
    }
}

export default TagListV13;